import i18n from "i18next"; // Import i18n for translations
import {
  blog1,
  blog2,
  blog3,
  c1,
  c2,
  c3,
  c4,
  c5,
  c6,
  counter1,
  counter2,
  counter3,
  counter4,
  t1,
  t2,
  t3,
  t4,
  t5,
  t6,
  t7,
  t8,
  t9,
  t10,
  t11,
  sp1,
  sp2,
  sp3,
  sp4,
  sp5,
  sp6,
  sp7,
  sp8,
  team1,
  team2,
  team3,
  team4,
  team5,
  team6,
  team7,
  team8,
} from "./images";

// Use i18n.t() instead of useTranslation()
export const achivementCounter = [
  {
    icon: counter1,
    num: "1",
    key: "enrolled_students",
  },
  {
    icon: counter2,
    num: "+2500",
    key: "academic_programs",
  },
  {
    icon: counter3,
    num: "+9700",
    key: "certified_students",
  },
  {
    icon: counter4,
    num: "+11",
    key: "award_winning",
  },
];
export const instructorData = [
  { img: team5, name: "Erics Widget", title: "UI/UX Designer" },
  { img: team6, name: "Daniel Steven", title: "Developer" },
  { img: team7, name: "Nelson Decosta", title: "Digital Marketer" },
  { img: team8, name: "Selina Gomez", title: "UI/UX Designer" },
];
export const topicsData = [
  {
    logo: t1,
    title: i18n.t("topics.1.title"),
    quantity: i18n.t("topics.1.quantity"),
  },
  {
    logo: t2,
    title: i18n.t("topics.2.title"),
    quantity: i18n.t("topics.2.quantity"),
  },
  {
    logo: t3,
    title: i18n.t("topics.3.title"),
    quantity: i18n.t("topics.3.quantity"),
  },
  {
    logo: t4,
    title: i18n.t("topics.4.title"),
    quantity: i18n.t("topics.4.quantity"),
  },
  {
    logo: t5,
    title: i18n.t("topics.5.title"),
    quantity: i18n.t("topics.5.quantity"),
  },
  {
    logo: t6,
    title: i18n.t("topics.6.title"),
    quantity: i18n.t("topics.6.quantity"),
  },
  {
    logo: t7,
    title: i18n.t("topics.7.title"),
    quantity: i18n.t("topics.7.quantity"),
  },
  {
    logo: t8,
    title: i18n.t("topics.8.title"),
    quantity: i18n.t("topics.8.quantity"),
  },
  {
    logo: t9,
    title: i18n.t("topics.9.title"),
    quantity: i18n.t("topics.9.quantity"),
  },
  {
    logo: t10,
    title: i18n.t("topics.10.title"),
    quantity: i18n.t("topics.10.quantity"),
  },
  {
    logo: t11,
    title: i18n.t("topics.11.title"),
    quantity: i18n.t("topics.11.quantity"),
  },
];
export const special_needs = [
  {
    logo: sp1,
    title: i18n.t("topics.1.title"),
    quantity: i18n.t("topics.1.quantity"),
  },
  {
    logo: sp2,
    title: i18n.t("topics.2.title"),
    quantity: i18n.t("topics.2.quantity"),
  },
  {
    logo: sp3,
    title: i18n.t("topics.3.title"),
    quantity: i18n.t("topics.3.quantity"),
  },
  {
    logo: sp4,
    title: i18n.t("topics.4.title"),
    quantity: i18n.t("topics.4.quantity"),
  },
  {
    logo: sp5,
    title: i18n.t("topics.5.title"),
    quantity: i18n.t("topics.5.quantity"),
  },
  {
    logo: sp6,
    title: i18n.t("topics.6.title"),
    quantity: i18n.t("topics.6.quantity"),
  },
  {
    logo: sp7,
    title: i18n.t("topics.7.title"),
    quantity: i18n.t("topics.7.quantity"),
  },
  {
    logo: sp8,
    title: i18n.t("topics.8.title"),
    quantity: i18n.t("topics.8.quantity"),
  },
];

export const blogArticleData = [
  { title: i18n.t("blog_articles.1"), img: c1 },
  { title: i18n.t("blog_articles.2"), img: c2 },
  { title: i18n.t("blog_articles.3"), img: c3 },
  { title: i18n.t("blog_articles.4"), img: c4 },
];

export const teamData = [
  { img: team1, name: "Erics Widget", title: "UI/UX Designer" },
  { img: team2, name: "Daniel Steven", title: "Developer" },
];

export const blogsData = [
  {
    img: blog1,
    type: "education",
    position: "admin",
    date: "jan 29, 2022",
    title: i18n.t("blog_articles.1"),
  },
  {
    img: blog2,
    type: "education",
    position: "admin",
    date: "jan 29, 2022",
    title: i18n.t("blog_articles.2"),
  },
  {
    img: blog3,
    type: "education",
    position: "admin",
    date: "jan 29, 2022",
    title: i18n.t("blog_articles.3"),
  },
];
export const courseData = [
  {
    id: 1,
    img: c1,
    title: "Web Development",
    description:
      "Learn how to build modern, responsive websites using HTML, CSS, and JavaScript.",
  },
  {
    id: 2,
    img: c2,
    title: "Graphic Design Basics",
    description:
      "Master the fundamentals of graphic design, including typography, color theory, and layout.",
  },
  {
    id: 3,
    img: c3,
    title: "Digital Marketing",
    description:
      "Understand SEO, social media marketing, and content marketing strategies to grow businesses online.",
  },
  {
    id: 4,
    img: c4,
    title: "Photography Masterclass",
    description:
      "Improve your photography skills with expert techniques and creative composition.",
  },
  {
    id: 5,
    img: c5,
    title: "Mobile App Development",
    description:
      "Build and deploy mobile applications for Android and iOS using modern frameworks.",
  },
  {
    id: 6,
    img: c6,
    title: "Cyber Security Basics",
    description:
      "Learn essential cybersecurity principles to protect yourself and your organization from threats.",
  },
  {
    id: 7,
    img: c2,
    title: "Interior Design",
    description:
      "Explore the art of interior design, from space planning to choosing the right colors and materials.",
  },
  {
    id: 8,
    img: c3,
    title: "Video Editing",
    description:
      "Learn video editing techniques using industry-leading software like Adobe Premiere Pro.",
  },
  {
    id: 9,
    img: c1,
    title: "Artificial Intelligence",
    description:
      "Understand AI fundamentals and how machine learning impacts various industries.",
  },
  {
    id: 10,
    img: c2,
    title: "Content Writing",
    description:
      "Develop writing skills for blogs, articles, and social media to create engaging content.",
  },
  {
    id: 11,
    img: c1,
    title: "3D Modeling",
    description:
      "Learn how to create realistic 3D models using software like Blender and Maya.",
  },
];
